import { cn } from "@/lib/utils"

/**
 * The inviting coach's face. Falls back to their initials — two letters read as
 * a person, a grey silhouette reads as a system.
 */
export function CoachAvatar({ src, initials, name, className, size = "md" }) {
  const sizes = {
    sm: "h-8 w-8 text-[11px]",
    md: "h-10 w-10 text-xs",
    lg: "h-14 w-14 text-base",
  }

  if (src) {
    return (
      <img
        src={src}
        alt={name ? `${name}, your coach` : ""}
        className={cn("shrink-0 rounded-full object-cover", sizes[size], className)}
      />
    )
  }

  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full",
        "bg-kf-red/10 font-semibold tracking-wide text-kf-red",
        sizes[size],
        className
      )}
    >
      {initials || "KF"}
    </span>
  )
}
